export class Direction {
    public static IsDescending(direction: 0 | 1 | -1): boolean {
        return direction === 1;
    }
    public static get Asc(): 0 {
        return 0;
    }
    public static get Desc(): 1 {
        return 1;
    }
    public static get None(): -1 {
        return -1;
    }
}